module.exports = __webpack_public_path__ + "img/icon-button-reject-dim.0aa40d61.svg";